(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-mobile-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function updateBadge(count) {
      document.querySelectorAll('[data-smn-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    // Keep the badge in sync with Horizon/Dawn cart update events.
    document.addEventListener('cart:update', function (evt) {
      var count = evt && evt.detail && typeof evt.detail.itemCount === 'number'
        ? evt.detail.itemCount
        : null;
      if (count !== null) {
        updateBadge(count);
      } else {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateBadge(cart.item_count); })
          .catch(function () {});
      }
    });

    document.addEventListener('cart:refresh', function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateBadge(cart.item_count); })
        .catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
